import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as emailApi from "@/services/emailApi";

export const emailTestingKeys = {
  all: ["email-testing"] as const,
  config: () => [...emailTestingKeys.all, "config"] as const,
  history: () => [...emailTestingKeys.all, "history"] as const,
};

export function useEmailConfig() {
  return useQuery({
    queryKey: emailTestingKeys.config(),
    queryFn: emailApi.getEmailConfig,
  });
}

export function useTestHistory() {
  return useQuery({
    queryKey: emailTestingKeys.history(),
    queryFn: emailApi.getTestHistory,
  });
}

export function useSendTestEmail() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: emailApi.sendTestEmail,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: emailTestingKeys.history() });
    },
  });
}
